const getPrecioPromedio = ({ precioTotal, sumaLibras }) => sumaLibras === 0 ? 0 : precioTotal / sumaLibras;

export default getPrecioPromedio